import {
  RecoverMetricTimeSeriesSchema,
  RecoverMetricTotalsSchema,
} from "@redotech/redo-marketing-core-common/aggregated-metrics/recover-conversation";
import { yyyyMmDdSchema } from "@redotech/zod-util/db-coercion";
import * as z from "zod";

const discountSplitStepSchema = z.object({
  automationId: z.string(),
  automationName: z.string(),
  stepId: z.string(),
  stepName: z.string(),
});

const discountSplitBucketSchema = z.object({
  steps: z
    .array(discountSplitStepSchema)
    .describe("Recover steps in this bucket"),
  metrics: z
    .array(RecoverMetricTimeSeriesSchema)
    .describe("Time series data for each recover metric"),
  totals: RecoverMetricTotalsSchema.describe(
    "Total values for each metric over the period",
  ),
});

export const GetRecoverDiscountSplitMetricsInputSchema = z.object({
  startDate: yyyyMmDdSchema.describe(
    "Start date for the analytics period (YYYY-MM-DD)",
  ),
  endDate: yyyyMmDdSchema.describe(
    "End date for the analytics period (YYYY-MM-DD)",
  ),
  teamId: z
    .string()
    .optional()
    .describe(
      "Team ID to fetch discount split metrics for; omit for all recover teams",
    ),
});

export const GetRecoverDiscountSplitMetricsOutputSchema = z.object({
  withDiscount: discountSplitBucketSchema.describe(
    "Metrics for steps whose recover config has a discount",
  ),
  withoutDiscount: discountSplitBucketSchema.describe(
    "Metrics for steps whose recover config has no discount",
  ),
});

export type GetRecoverDiscountSplitMetricsInput = z.infer<
  typeof GetRecoverDiscountSplitMetricsInputSchema
>;
export type GetRecoverDiscountSplitMetricsOutput = z.infer<
  typeof GetRecoverDiscountSplitMetricsOutputSchema
>;

export const getRecoverDiscountSplitMetrics = {
  name: "getRecoverDiscountSplitMetrics" as const,
  input: GetRecoverDiscountSplitMetricsInputSchema,
  output: GetRecoverDiscountSplitMetricsOutputSchema,
};
